export default __webpack_public_path__ + "static/media/aboutImg.63b91fc9.jpg";